module.exports = __webpack_public_path__ + "static/media/tell_me_my_way.ad522624.mp4";